import { ContactBriefingPage } from "@pages/ContactBriefingPage";
import { ContactsListPage } from "@pages/ContactsListPage";
import { ProfileReviewPage } from "@pages/ProfileReviewPage";
import { sidekickModuleEnum } from "@shared/access-control/sidekick-modules";
import { ContactsLayoutSkeleton } from "@features/Contacts/layouts/ContactsLayoutSkeleton";
import { AppRoute } from "./types";
import { CrmGuard } from "./components/CrmGuard";
import { PROFILE_REVIEW_PATH } from "@shared/utils/contact-briefing-links";

export const contactsRoutes: AppRoute[] = [
  {
    path: "/contacts",
    element: (
      <CrmGuard>
        <ContactsListPage />
      </CrmGuard>
    ),
    protected: true,
    fallback: <ContactsLayoutSkeleton />,
  },
  {
    path: PROFILE_REVIEW_PATH,
    element: (
      <CrmGuard>
        <ProfileReviewPage />
      </CrmGuard>
    ),
    protected: true,
    requiredModule: sidekickModuleEnum.RADAR,
    fallback: <ContactsLayoutSkeleton />,
  },
  {
    path: "/contacts/:contactId",
    element: (
      <CrmGuard>
        <ContactBriefingPage />
      </CrmGuard>
    ),
    protected: true,
    fallback: <ContactsLayoutSkeleton />,
  },
];
